import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import CustomerAppHeader from "./CustomerAppHeader";
import CustomerAppSidebar from "./CustomerAppSidebar";


const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen dark:bg-[linear-gradient(135deg,_#1e293b_0%,_#334155_50%,_#0f172a_100%)] bg-[linear-gradient(135deg,_#EFF2FF_0%,_#FAF5FF_50%,_#FCF3FB_100%)] xl:flex">
      <div>
        <CustomerAppSidebar/>
        <Backdrop />
      </div>
      <div
        className={`flex-1  transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "ltr:lg:ml-[290px] rtl:lg:mr-[290px]" : "ltr:lg:ml-[90px] rtl:lg:mr-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
         <CustomerAppHeader/>
        <div className="mx-0 p-0  max-w-[var(--breakpoint-2xl)]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const CustomerLayout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default CustomerLayout;
